import { render, staticRenderFns } from "./AddCampaignForm5.vue?vue&type=template&id=0b01576a&"
import script from "./AddCampaignForm5.vue?vue&type=script&lang=js&"
export * from "./AddCampaignForm5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports